// Launch switches and brand constants. Values come from the environment so the
// same build can be pointed at another domain, inbox or social account.
export const SITE_URL = process.env.REACT_APP_SITE_URL;

// Confirmed inbox for every enquiry from the website.
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL;

export const INSTAGRAM_URL = process.env.REACT_APP_INSTAGRAM_URL;

// Bilingual code stays in place; the EN switch is hidden until the
// translations (and /en/ routes + hreflang) are approved.
export const EN_ENABLED = false;

// Web forms send through the Emergent managed email integration (backend only,
// key never reaches the browser) to CONTACT_EMAIL.
export const FORMS_ENABLED = true;

// Legal pages are published and linked from the footer. They keep a visible
// notice and stay noindex until the registry data is filled in.
export const LEGAL_ENABLED = true;
